import {
  getPageDecorations,
  setDocumentTitle,
  useSiteNameContext,
} from "../../context/siteNameContext";
import classNames from "classnames";

function ExamHeader() {
  const { siteNameList } = useSiteNameContext();
  setDocumentTitle(siteNameList, "exam");
  const decorations = getPageDecorations(siteNameList, "exam");

  return (
    <div className="ExamHeader">
      <div className="Wrapper">
        <h1
          className="ExamTitle"
          dangerouslySetInnerHTML={{ __html: decorations?.header1 }}
        ></h1>
      </div>

      <div className={classNames(["Wrapper", "ColorWhite"])}>
        <div className="ExamGrid">
          <p dangerouslySetInnerHTML={{ __html: decorations?.text1 || "" }} />
          <img src={"/images/examimg.png"} alt={""} />
        </div>
      </div>
    </div>
  );
}

export default ExamHeader;
